import Vue from 'vue'
import Router from '../router/index'
import Store from '../store/index'
import {fetchUserInfo, API_STATUS} from '../store/api'
import {backurl} from "../util/params";


let Base64 = require('js-base64').Base64;
/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  content = Base64.encode(content);
  window.localStorage.setItem(name, content);
}
/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  let storage = window.localStorage.getItem(name);
  if (storage) {
    storage = Base64.decode(storage);
    if (typeof storage === 'string') {
      storage = JSON.parse(storage);
    }
    return storage;
  } else {
    return storage;
  }
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}

//=====登录相关=====
export const getLoginInfo = () => {

  let logininfo = getStore('logininfo');
  if (logininfo) {
    let logininfotime = logininfo.createtime;
    if ((Date.parse(new Date()) - logininfotime) / 1000 > 86400) {
      removeStore('logininfo');
      Store.commit('updateUserInfo', {loginInfo: null});

      return null;
    }
    Store.commit('updateUserInfo', {loginInfo: null});





  }
  return logininfo;
}


export const setLoginInfo = (logininfo,to) => {
  //设置本地缓存
  removeStore('logininfo');
  //修改 store
  logininfo.createtime = Date.parse(new Date());
  setStore('logininfo', logininfo);
  Store.commit('updateUserInfo', {loginInfo:logininfo});
  //跳转
  let lastlogin = getStore('lastlogin');

  if (to) {
    Router.push(lastlogin)
  } else if(lastlogin){
    Router.push(lastlogin);
  }else{
    Router.push({name: 'usercenter'});
  }
}

export const Login = (route) => {
  //第一步 保存用户登录信息
  let lastlogin = {name: route.name, params: route.params}
  setStore('lastlogin', lastlogin);
  //第二步 调用微信登录
  const wechatappid = wechatconfig.appid
  const redirecturl = encodeURIComponent(host + "login");

  let encodeurl = encodeURIComponent("http://www.moveclub.cn/getwechatcode/getcode.php?redirect_url=" + redirecturl);
  let jumpurl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + wechatappid + "&redirect_uri=" + encodeurl + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
  window.location.href = jumpurl;
  return false;
}

export const Logout = () => {
  removeStore('logininfo');
  removeStore('lastlogin');
  Store.commit('updateUserInfo', {loginInfo: null});
  window.location.href = host;

}
export const JdAuth = (route) => {
  //第一步 保存用户登录信息
  let lastlogin = {name: route.name, params: route.params}
  setStore('lastlogin', lastlogin);
  let jumpurl = "https://bt.jd.com/v3/mobile/zoneAuth?source=sCamRun2&backURL=https://btzone.jd.com/zone/wxrun.do";
  window.location.href = jumpurl;
  return false;
}


export const checkmobile = function(mobile) {
  let myreg = /^1\d{10}$/;
  if(!myreg.test(mobile))
  {
    return false;
  }
  return true;
}

//=====登录相关结束=====





// WEBPACK FOOTER //
// ./src/util/util.js